import React from "react";
import { HiOutlineArrowLeft } from "react-icons/hi2";
import { useLanguage } from "../../../contexts/LanguageContext";

export function PosterCreatorHeader({ onBack }) {
  const { t } = useLanguage();

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8">
      <div>
        <h1 className="text-2xl font-bold text-white tracking-tight">
          {t("createPoster")}
        </h1>
        <p className="text-white/70 text-sm mt-0.5">
          {t("createPosterSubtitle")}
        </p>
      </div>
      <button
        onClick={onBack}
        className="flex items-center gap-2 px-4 py-2 rounded-lg bg-ink-100 hover:bg-ink-200 text-ink-700 dark:bg-white/10 dark:hover:bg-white/20 dark:text-white text-sm font-medium transition-colors w-fit"
      >
        <HiOutlineArrowLeft className="w-4 h-4" />
        {t("addRecipeBack")}
      </button>
    </div>
  );
}
